import React from "react";

const DetailBillFake = () => {
  return (
    <>
      <section className="container all-bills-fake">
        <div className="all-bills-fake--column-1">
          <div className="all-bills-fake--column-1--header">
            <div className="skeleton all-bills-fake--column-1--header--title" />
            <div className="all-bills-fake--column-1--header--box">
                <div className="skeleton all-bills-fake--column-1--header--box--period" />
                <div className="skeleton all-bills-fake--column-1--header--box--period" />
            </div>
          </div>
          <div className="skeleton all-bills-fake--column-1--boxes" />
        </div>
      </section>
      <style jsx>{`
        .all-bills-fake {
          display: flex;
          flex-direction: column;
          &--column-1 {  
            &--boxes {
              margin-top: 1rem;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              width: 100%;
              height: 600px;
            }
            &--header {
              display: flex;
              flex-direction: column;
              align-items: start;
              width: 100%;
              gap: 1rem;
              &--title {
                width: 33%;
                height: 24px;
              }
              &--box {
                width: 100%;
                display: flex;
                align-items: start;
                &--period {
                    width: 25%;
                    height: 18px;
                }
              }
            }
          }
        }
        @media (min-width: 768px) {
          .all-bills-fake {
            flex-direction: row;
            justify-content: space-between;
            &--column-1 {
              width: 70%;
            }
            &--column-2 {
              padding: 0 2rem;
            }
          }
        }
      `}</style>
    </>
  );
};

export default DetailBillFake;